import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteServiceFeeDocument,
  DeleteServiceFeeMutation,
} from "../generated-gql/graphql";

export const bulkDeleteAction: BulkAction = {
  location: "service-fee-table",
  label: "Delete Selected Service fee",
  icon: "trash",
  iconClass: "is-danger",
  // requiresPermission: (userPermissions) =>
  //   userPermissions.includes("DeleteArtist"),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: "Delete Selected Service Fee",
        body: `Are you sure you want to delete ${selection.length} service fees?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteServiceFeeMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteServiceFeeDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            let deletedCount = 0;
            res.forEach((r) => {
              const { deleteServiceFee } = r;
              if (deleteServiceFee.result === "DELETED") {
                deletedCount++;
              }
              if (deletedCount > 0) {
                notificationService.success(
                  `Deleted ${deletedCount} cron jobs sucessfully`
                );
              }
            });
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};
